import jelly from '../elements/jelly.js';
jelly.register();
